export var TOUCHMOVE = "touchmove";
export var KEYDOWN = "keydown";